import { s, g as t } from "./chunks/runtime.js";
/*! All material copyright Esri, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
v4.32.14 */
const a = s, A = t;
export {
  A as getArcgisAssetPath,
  t as getAssetPath,
  a as setArcgisAssetPath,
  s as setAssetPath
};
